import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import MapIcon from '@mui/icons-material/Map';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';

import GoogleMapWithMarkers from '../../../../ContentParts/GoogleMapWithMarkers';

const MapSection = ({ displayChalets, zoom }) => {
    const [expanded, setExpanded] = useState(false);
    const [mapObject, setMapObject] = useState({
        map: {
            name: '',
            lat: 0, // Default latitude
            lng: 0, // Default longitude
            individualMap: true,
            mapId: ''
        },
        markers: []
    });

    useEffect(() => {


        if (displayChalets && displayChalets.length > 0) {
            const firstChalet = displayChalets[0];
            setMapObject({
                map: {
                    name: firstChalet.name,
                    lat: firstChalet.lat,
                    lng: firstChalet.lng,
                    individualMap: true,
                    mapId: "map" + firstChalet.id
                },
                markers: displayChalets.map(chalet => ({
                    lat: chalet.lat,
                    lng: chalet.lng,
                    title: chalet.name,
                    link:chalet.link,
                    id: chalet.id,
                    infoWindowTitle: chalet.name,
                    infoWindowDesc: chalet.totalStayFormatted,
                    infoWindowLink: chalet.link
                    // Markers for each chalet
                }))
            });
        } else {
            // When displayChalets is empty, keep the map but remove markers
            setMapObject(prevMapObject => ({
                ...prevMapObject,
                markers: []
            }));
        }
    }, [displayChalets]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };


    return (
        <Card>
            <IconButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
            >
                <MapIcon />
                <ExpandMoreIcon />

            </IconButton>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <div id="chaletMap">
                        <GoogleMapWithMarkers mapObject={mapObject} zoom={zoom} />
                    </div >
                </CardContent>
            </Collapse>
        </Card>
    );
};

export default MapSection;

